import * as React from 'react';

const ChatCenterIcon = ({fillColor = '#2D2756'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none">
    <path
      stroke={fillColor}
      strokeWidth={1.2}
      d="M10.011 9.385h.002a1.578 1.578 0 0 0 1.574-1.557 1.52 1.52 0 0 0-1.592-1.596H6.105a1.578 1.578 0 0 0-1.574 1.559 1.522 1.522 0 0 0 1.592 1.594h3.888ZM.851 4.88v-.006A4.233 4.233 0 0 1 5.124.6h5.868a4.232 4.232 0 0 1 4.275 4.275v9.803a.324.324 0 0 1-.207.321.32.32 0 0 1-.133.02H5.125A4.232 4.232 0 0 1 .85 10.742V4.881Z"
    />
  </svg>
);

export default ChatCenterIcon;
